import React from "react";
import style from "../../style/Pages/Help/ActivityHelp.module.css"; // Reuse or rename as needed
import { Link } from "react-router-dom";
import { GrGroup } from "react-icons/gr";
import { TbArrowLeft } from "react-icons/tb";
import SecondaryLayout from "../../layouts/SecondaryLayout";

const ActivityHelp = () => {
  return (
    <>
      <SecondaryLayout>
        <div className={style.accountHelpWrapper}>
          <Link to="/help" className={style.backLink}>
            <TbArrowLeft className={style.backIcon} /> Back to Help Center
          </Link>

          <div className={style.header}>
            <GrGroup className={style.headerIcon} />
            <h1>Activity</h1>
          </div>

          <div className={style.content}>
            <p>
              The <strong>Activity</strong> section gives you a real-time
              overview of what’s happening in your chat environment — helping
              you stay updated and responsive.
            </p>

            <h2>📢 Mentions</h2>
            <ul>
              <li>
                Any message where you are tagged using @yourname appears in your
                activity feed.
              </li>
              <li>
                Mentions help you catch important updates without scanning every
                chat.
              </li>
              <li>
                You can click on a mention to jump directly to that message.
              </li>
            </ul>

            <h2>😎 Reactions</h2>
            <ul>
              <li>Reactions let users respond to messages with emojis.</li>
              <li>
                All reactions you’ve received (👍 ❤️ 😂 etc.) show up in the
                Activity view.
              </li>
              <li>
                Click on a reaction to view who reacted and to what message.
              </li>
            </ul>

            <h2>📨 All Messages</h2>
            <ul>
              <li>
                The Activity tab displays recent messages from all groups,
                channels, and direct chats you’re part of.
              </li>
              <li>
                This includes unread messages and message previews with
                timestamps.
              </li>
              <li>
                Helps you prioritize your conversations and avoid missing
                anything important.
              </li>
            </ul>

            <p>
              With the Activity section, you're always in the loop — no matter
              how busy your chats get.
            </p>
          </div>
        </div>
      </SecondaryLayout>
    </>
  );
};

export default ActivityHelp;
